import { React, useState, useContext, useEffect } from "react";
import TemplateItem from './dashboard.templateItem.component';
import CharacterContext from '../../context/CharacterContext';
import AuthContext from "../../context/userAuth.context";
import axios from "axios";

const AllPopularTemplates = ({ setpopupload, popupload, setCurrentchoose, setShowTemp }) => {
    const [DataArray, setDataArray] = useState([])
    const { authenticationData } = useContext(AuthContext);

    useEffect(() => {
        if (DataArray.length == 0) {
            let authData = JSON.parse(
                localStorage.getItem("animation_studio_2.0_access_token")
              );
              axios
                .get(
                  authenticationData.ApiBaseURL + "/api/Template/NextTemplatesRecord?count=0&nextNumber=10",
                  {
                    headers: {
                      "Content-Type": "application/json",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: "Bearer " + authData.access_token,
                    },
                  }
                )
                .then((response) => {
                    setDataArray(response.data.popularTemplates);
                }).catch((error) => {
                    
                })
        }
    }, [])

    const pushNewItems = () => {


        let totalLoaded = DataArray.length;
        let newLength = totalLoaded + 2;


        let arr2 = JSON.parse(JSON.stringify(DataArray));
        let authData = JSON.parse(
            localStorage.getItem("animation_studio_2.0_access_token")
          );
          axios
            .get(
              authenticationData.ApiBaseURL + "/api/Template/NextTemplatesRecord?count=" + totalLoaded + "&nextNumber=10",
              {
                headers: {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + authData.access_token,
                },
              }
            )
            .then((response) => {
                for (let i = 0; i < response.data.popularTemplates.length; i++) {
                    arr2.push(response.data.popularTemplates[i])
                    
                }
                setDataArray(arr2);
            }).catch((error) => {
                
            })


    }

    const windowScrollBinding = () => {
        window.onscroll = function (e) {
            const bottom = e.target.scrollingElement.scrollHeight - e.target.scrollingElement.scrollTop === e.target.scrollingElement.clientHeight;
            if (bottom) {
                pushNewItems()
            }
        }
    }

    return (
        <div onLoad={windowScrollBinding}>

            <div className="row mb-3">
                <div className="col-12">
                    <h5 className="d-inline-block">All Popular Templates</h5>
                    <a className="btn float-right pointer viewAll " onClick={() => {
                        let obj = {
                            Recent: true,
                            AllRecent: false,
                            Popular: true,
                            AllPopular: false
                        }
                        setShowTemp(obj)
                    }}>
                        <span class="material-icons">
                            clear
                        </span>
                    </a>
                </div>
            </div>

            <div className="gridViewTemplates mt-2">

                {DataArray.map((value, index) => {
                    return <>
                        <TemplateItem key={index} start={setCurrentchoose} ProjectData={value} showpop={setpopupload} checkpop={popupload}
                            imgRatio="1.5" flexGrow="20" paddingRatio="50" imgSrc={value.previewImagePath} title={value.projectName} />
                    </>
                })}
            </div>
        </div>
    )
}

export default AllPopularTemplates;